import React from 'react'
import { Field } from 'formik'
import borderRadius from '../../../../../theme/borderRadius'
import colors from '../../../../../theme/colors'
import Label from '../../../../Label'
import RemoveCustom from './RemoveCustom'
import name from './lib/name'

export default ({ baseName, custom, editable, arrayHelpers, ...rest }) => {
  if (editable) {
    return (
      <Field
        name={`${baseName}.label`}
        onFocus={() => arrayHelpers.form.setFieldValue(`${baseName}.filled`, false)}
        onBlur={() => arrayHelpers.form.setFieldValue(`${baseName}.filled`, true)}
        style={styles.field}
        placeholder='Other...'
      />
    )
  }

  return (
    <div style={styles.container}>
      {custom && <RemoveCustom arrayHelpers={arrayHelpers} {...rest} />}
      <Label
        {...rest}
        htmlFor={name(baseName)}
      />
    </div>
  )
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  field: {
    height: '34px',
    borderRadius: `0 ${borderRadius} ${borderRadius} 0`,
    border: `1px solid ${colors.lightGrey}`,
    padding: '0 10px',
    fontSize: '14px',
    width: '200px',
  },
}
